import getCustomFiltersAsQueryParams from './getCustomFiltersAsQueryParams';

const getFilterValues = (state) => state.playersAndTeams.filter.values;

export default {
    getCustomFiltersAsQueryParams,
    getFilterValues,
};
